import { render, staticRenderFns } from "./FixedBanner.vue?vue&type=template&id=05a02b44&scoped=true&"
import script from "./FixedBanner.vue?vue&type=script&lang=js&"
export * from "./FixedBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a02b44",
  null
  
)

export default component.exports